<template>
  <v-container>
    <ContainerPicker
      v-model="value.container"
      title="Dialog"
      :containers="containers"
      :is-required="true"
      type="Dialog"
    />
  </v-container>
</template>

<script>
import ContainerPicker from "../shared/ContainerPicker.vue";

export default {
  name: "ShowDesigner",

  components: { ContainerPicker },

  props: ["value", "containers"],
};
</script>
